import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpService } from 'src/app/http.service';
import { GlobalService } from 'src/app/global.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';
@Component({
  selector: 'app-super-sale-group-wallet',
  templateUrl: './super-sale-group-wallet.component.html',
  styleUrls: ['./super-sale-group-wallet.component.scss']
})
export class SuperSaleGroupWalletComponent implements OnInit {
  is_data_available = false;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  counter_data: any = null;

  constructor(public dialogRef: MatDialogRef<SuperSaleGroupWalletComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private http: HttpService, private global: GlobalService) {
    console.log(data);
    this.is_data_available = true;
    let data_dict = {
      'from_date': data['from_date'],
      'to_date': data['to_date'],
      'selected_business_code': data['business_code']
    };
    this.http.serveSuperSaleGroupForWallet(data_dict).subscribe((data) => {
      console.log(data);
      this.is_data_available = false;
      this.counter_data = data;
    }, (error) => {
      this.is_data_available = false;
      console.error(error);
    });
  }

  closeClicked() {
    this.dialogRef.close();
  }

  ngOnInit() {
  }

}
